<template>
  <div class="movement">
    <div class="column">
      <div> <span :class="movementAmountClass">{{movement.amount | currency('€', 2, {symbolOnLeft:false, thousandsSeparator: '.', decimalSeparator :','})}}</span> </div>
      <div> <span>{{movement.concept}} </span> </div>
    </div>
    <div class="column">
      <div><span> {{movement.date | formatTheDate('short_date_year_long_time', true)}} </span> </div>
      <div v-if="movement.invoice">
        <span
          class="invoice-link"
          @click="downloadInvoice(movement.invoice)"
        >{{$t(downloadLabel)}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { getResourceFromAws } from '@/shared/_api'
export default {
  name: 'DashboardMovementRow',
  props: {
    movement: {
      type: Object
    }
  },
  data () {
    return {
      isDownloadingInvoice: false
    }
  },
  computed: {
    movementAmountClass () {
      if (this.movement.amount > 0) {
        return 'status--green'
      } else {
        return 'status--red'
      }
    },
    downloadLabel () {
      return this.isDownloadingInvoice ? 'media_viewer_fetching_resource' : 'dashboard_top_up_history_action_download_invoice'
    }
  },
  methods: {
    async downloadInvoice (invoiceData) {
      if (this.isDownloadingInvoice) return
      try {
        this.isDownloadingInvoice = true
        // const mediaURL = await getMediaUrl(invoiceData.id)
        // const response = await getUrlResource(mediaURL.data[0])

        const response = await getResourceFromAws(invoiceData.id)

        let itemLink = document.createElement('a')
        itemLink.href = URL.createObjectURL(response.data)
        itemLink.download = `movement-invoice-${invoiceData.id}-`
        itemLink.click()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'dashboard_download_invoice_error' })
      } finally {
        this.isDownloadingInvoice = false
      }
    }
  }
}
</script>

<style scoped>
/* Update When Redesigned! */
.movement {
  display: flex;
  border-top: 1px solid var(--fill-background);
  border-bottom: 1px solid var(--fill-background);
  padding: 8px 0px;
}
.movement > .column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 50%;
}

.movement > .column:last-child {
  align-items: flex-end;
}
.invoice-link {
  cursor: pointer;
  color: var(--blue-action-1-active);
  font-weight: 500;
  text-decoration: underline;
}
</style>
